import "./style"

export default function Index(props) {
  return (<div className="components-animated-transition" {...props}/>)
}
